export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/fi.lyaml"));
at({ "fi": { "public": { "sampleString": "N\xE4ytemerkkijono" } } });
};